import { Link } from "react-router-dom";
import css from './index.module.css';
import SEO from "@components/seo";
import MainContent from "@components/content";

export default function EmptyCart () {
  return (
    <MainContent header="Корзина">    
      <SEO 
        title="Корзина пуста"
        description="Рыбный мир"
        ogUrl="https://рыбныимир.рф/"
      />

      <div className={css.component} style={{ margin: 0, marginTop: 10 }}>        
        <div>    
          <h1 style={{ marginBottom: 15, fontSize: 24 }}>Товаров нет</h1>
          <a style={{ fontSize: 16, color: "#0000009f" }}>Добавьте товары в корзину и перейдите на эту страницу для оформления заказа</a>

          <Link to={`/webapp`} className={css.back}>Перейти в каталог</Link>
        </div>
      </div>
    </MainContent>
  )
}
